@let ckAfd = afd()?.afdeling();
<div class="card-container">
    <kendo-card width="260px" (click)="onClick()" class="clickable" [class.selected]="selected()">
        <kendo-card-body>
            <div class="header">
                <span class="afd-titel">{{ckAfd?.titel}}</span>
                <span title="{{typeKey(ckAfd?.type?.value)}}">{{ckAfd?.type?.value | tkdata:'afdtype':{default: ''} | async}}</span>
                <span>Ref: {{(ckAfd!.refNr -1)}}</span>
                <div class="header-row">
                    <button kendoButton [themeColor]="'primary'" (click)="this.onClick(); this.kopConfigService.isDetail.set(true)">{{'Modules bewerken' | translate: 'Modules bewerken'}}</button>
                    <button kendoButton (click)="removeDialogOpen = true" [svgIcon]="trashIcon"></button>
                    <button kendoButton (click)="this.onCopy()" [svgIcon]="copyIcon"></button>
                    <paste [currentAfd]="afd()" dialogTitle="{{'Verplaatsen Afdeling' | translate: 'Verplaatsen Afdeling'}}"/>
                </div>
            </div>
            <!-- @if (this.selected()) {                
                <validation-info [validation]="validation()" />
            } -->
        </kendo-card-body>
    </kendo-card>
    <!-- @if (!this.isValid()) {
        <div class="ribbon">Check errors!</div>
    } -->
    
</div>

<kendo-dialog *ngIf="removeDialogOpen" title="{{'Remove Afdeling' | translate: 'Remove Afdeling'}}" width="300px" (close)="removeDialogOpen = false">
    <p>{{'Are you sure you want to delete {title}?' | translate: 'Are you sure you want to delete {title}?': {title: ckAfd?.titel?.toString() || ""} }}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="removeDialogOpen = false">{{'Cancel' | translate: 'Cancel'}}</button>
        <button kendoButton (click)="onRemove()" themeColor="primary">
            {{'Remove' | translate: 'Remove'}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>